module.exports = __webpack_public_path__ + "static/media/payment-paypal.23de6718.png";